import emblem from './emblem-dap.png'

/**
 * Emblème de l'Administration pénitentiaire du Sénégal.
 *
 * ⚠️ PROVISOIRE : extrait du guide de marque. Remplacer `emblem-dap.png` par le
 * fichier officiel (https://administrationpenitentiaire.sn/wp-content/uploads/2020/07/logo_dap.png),
 * détouré (fond transparent), sans le redimensionner ni le recolorer.
 * Règles : proportions d'origine, jamais recréé en CSS, lisible sur fond clair et foncé.
 */
export const EMBLEM_URL: string = emblem

export const INSTITUTION = {
  name: 'Administration pénitentiaire',
  country: 'du Sénégal',
  fullName: 'Administration pénitentiaire du Sénégal',
  platform: 'Système intégré de gestion de concours',
  /** Proposition graphique — à faire valider avant tout usage comme devise officielle. */
  signature: ['Discipline', 'Sécurité', 'Réinsertion'],
} as const
